import * as actionTypes from '../../customerAreaActionTypes';
import { AppThunk, Project } from '@greenkub-fronts/shared/interface';
import { initCurrentProject } from '../initCurrentProject/init-current-project.use-case';

export const pickCurrentProject =
  (selectedCurrentProject?: Project): AppThunk =>
  async (dispatch, getState) => {
    const query =
      getState().api.queries[
        'getAllCustomerProjects({"groupName":"ProjectsForCustomerArea"})'
      ];

    let automaticCurrentProject: undefined | Project = undefined;

    /**
     * If all the project is loaded, we pick a currentProject
     */
    if (query && query.status === 'fulfilled') {
      const projects: Project[] = query.data;

      /**
       * Search for the first project with configuration
       */
      if (!selectedCurrentProject) {
        for (const project of projects) {
          if (project.configurations.length > 0) {
            automaticCurrentProject = project;
            break;
          }
        }
      }

      if (!automaticCurrentProject && !selectedCurrentProject) return;

      if (automaticCurrentProject || selectedCurrentProject) {
        const definitiveProject = selectedCurrentProject
          ? selectedCurrentProject
          : automaticCurrentProject;

        if (!definitiveProject) return;

        /**
         * Set current project Id
         */
        await dispatch({
          type: actionTypes.SET_CURRENT_PROJECT,
          payload: { currentProjectId: definitiveProject.id },
        });
      }

      dispatch(initCurrentProject({}));
    }
  };
